import { z } from 'zod';
export const TopicDTO = z.object({
    id: z.guid(),
    key: z.string(),
    name: z.string(),
    description: z.string(),
    sortOrder: z.number().int(),
    deletedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateTopicRequest = z.object({
    key: z
        .string()
        .regex(/^[a-z0-9_]+$/, 'lowercase letters, digits, underscore')
        .min(2)
        .meta({ label: 'Ключ' }),
    name: z.string().min(1).meta({ label: 'Название' }),
    description: z.string().optional().meta({ label: 'Описание' }),
    sortOrder: z.number().int().optional().meta({ label: 'Порядок' }),
});
export const UpdateTopicRequest = z.object({
    name: z.string().min(1).optional().meta({ label: 'Название' }),
    description: z.string().optional().meta({ label: 'Описание' }),
    sortOrder: z.number().int().optional().meta({ label: 'Порядок' }),
});
//# sourceMappingURL=topics.js.map